// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.treeview-container {
  -webkit-user-select: none;
          user-select: none;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.tree-root {
  position: relative;
}

.tree-node {
  transition: background-color 0.15s ease-in-out;
}

.subtotal-node:hover {
  background-color: rgba(var(--ct-primary-rgb), 0.05) !important;
}

.account-node:hover {
  background-color: var(--ct-light) !important;
}

.tree-branch {
  position: relative;
  border-left: 1px solid var(--ct-border-color);
}
.tree-branch::before {
  content: "";
  position: absolute;
  top: -0.5rem;
  left: -1px;
  width: 1px;
  height: 0.5rem;
  background-color: var(--ct-border-color);
}

.tree-item {
  position: relative;
}
.tree-item::before {
  content: "";
  position: absolute;
  top: 1.25rem;
  left: -1.5rem;
  width: 1.5rem;
  height: 1px;
  background-color: var(--ct-border-color);
}
.tree-root > .tree-item::before {
  display: none;
}

.transition-icon {
  transition: transform 0.2s ease;
}

.subtotal-node[aria-expanded=true] .transition-icon {
  transform: rotate(0deg);
}

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.badge {
  font-size: 0.7rem;
}

.modal-header {
  border-bottom: 0;
}

.modal-footer {
  border-top: 1px solid var(--ct-border-color);
}

/* Scrollbar styling */
.treeview-container::-webkit-scrollbar {
  width: 6px;
}

.treeview-container::-webkit-scrollbar-track {
  background: transparent;
}

.treeview-container::-webkit-scrollbar-thumb {
  background: var(--ct-secondary-bg);
  border-radius: 10px;
}

.treeview-container::-webkit-scrollbar-thumb:hover {
  background: var(--ct-secondary);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
